const env = process.env.REACT_APP_ENV || 'prd' // 默认是prd

const pdfParse = {
  prd: {
    main: 'http://pc.hive-intel.com/api',
    mainProcess: 'http://pc.hive-intel.com/remain-processer',
  },
  test: {
    main: 'http://api.hive-intel.qa/main',
    mainProcess: 'http://api.hive-intel.qa/remain-processer',
  },
  dev: {
    main: 'http://react-frontend.hive-intel.devop/main',
    mainProcess: 'http://react-frontend.hive-intel.devop/remain-processer',
  },
  mock: {
    main: 'https://mock',
    mainProcess: 'https://mock',
  },
}
const api = {
  url: pdfParse[env],
}
export default api



// WEBPACK FOOTER //
// ./src/utils/api.config.js